import React from 'react';
import styled from 'styled-components';
import {BodyContainer} from "../Container/Container";
import bg from '../../assets/img/section1BG.jpg';
import {P1, SectionTitle} from "../Kit/Kit";
import ValueCards from "./ValueCards";

const StyledBodyContainer = BodyContainer.extend`
     @media (min-width: 768px) {
        background: url(${bg}) top no-repeat;
        background-size: contain;
        padding-top: 60px;
        padding-bottom: 120px;
      }
`;

const StyledSectionTitle = SectionTitle.extend`
  margin-bottom: 16px;
  
  @media(min-width: 768px){
    margin-bottom: 20px;
  }
  
  @media(min-width: 992px) {
    margin-bottom: 24px;
  }
`;

const SectionDescription = P1.extend`
  margin-bottom: 24px;
  
  @media(min-width: 768px){
    margin-bottom: 35px;
  }
  
  @media(min-width: 992px) {
    margin-bottom: 60px;
  }
`;

const ValueContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  grid-column-gap: 32px;
  @media(min-width: 768px){
    grid-template-columns: repeat(4, 1fr);
    
  }
`;

const ValuesData = [
    {
        letter: 'F',
        title: 'Family',
        description: 'We strive to treat our customers, vendors, and employees like family.'
    },
    {
        letter: 'I',
        title: 'Integrity',
        description: 'We up-hold the highest standard of ethical conduct, honesty, and integrity.'
    },
    {
        letter: 'S',
        title: 'Service',
        description: 'We are diligent in our desire to provide our customers the best service in the business.'
    },
    {
        letter: 'H',
        title: 'Hard Work',
        description: 'We trust that we will achieve our goals and mission through hard work.'
    },
];

const Mission = (props) => {
    const {header, paragraph} = props.data;
    return (
      <StyledBodyContainer>
          <StyledSectionTitle
            dangerouslySetInnerHTML={{__html: header}}
          />
          <SectionDescription
            dangerouslySetInnerHTML={{__html: paragraph}}
          />
          <ValueContainer>
              {ValuesData.map((i) => <ValueCards key={i.title} letter={i.letter} title={i.title}
                                                 description={i.description}/>)}
          </ValueContainer>
      </StyledBodyContainer>
    );
};

export default Mission;



// WEBPACK FOOTER //
// ./src/components/GetToKnow/Mission.js